import { useState, useEffect } from 'react';

const LOGO = 'https://static.readdy.ai/image/705f25322c737a89d377410a2840897b/562dc63b58250b7932862d714c3260fa.png';

const NAV_ITEMS = [
  { label: 'Project Details', id: 'project-details' },
  { label: 'Location Map', id: 'location-map' },
  { label: 'Gallery', id: 'gallery' },
  { label: 'Enquiry Form', id: 'enquiry-form' },
  { label: 'Contact', id: 'contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        scrolled ? 'bg-white border-gray-200 shadow-sm' : 'bg-white border-gray-200'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-8 flex items-center justify-between h-16">
        {/* Logo */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex-shrink-0 cursor-pointer"
        >
          <img src={LOGO} alt="Bayshore Logo" className="h-10 w-auto object-contain" />
        </button>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-7 xl:gap-9">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-medium text-[#172C37] hover:text-[#172C37]/50 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Right: phone + CTA */}
        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:+6593651286"
            className="text-sm font-semibold text-[#172C37] hover:text-[#172C37]/60 transition-colors whitespace-nowrap"
          >
            +65 9365 1286
          </a>
          <button
            onClick={() => scrollTo('enquiry-form')}
            className="bg-[#172C37] text-white text-sm font-bold px-5 py-2.5 rounded-full hover:opacity-70 transition-opacity whitespace-nowrap cursor-pointer"
          >
            Book Viewing
          </button>
        </div>

        {/* Mobile: WhatsApp + Hamburger */}
        <div className="lg:hidden flex items-center gap-2">
          <a
            href="https://wa.me/6593651286?text=Hi%2C%20I%20am%20interested%20in%20the%20Vela%20Bay%20project"
            target="_blank"
            rel="nofollow noreferrer"
            aria-label="WhatsApp"
            className="w-9 h-9 flex items-center justify-center bg-[#25D366] rounded-full cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl text-white" />
          </a>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="cursor-pointer w-9 h-9 flex items-center justify-center"
            aria-label="Toggle menu"
          >
            {mobileOpen ? (
              <i className="ri-close-line text-2xl text-[#172C37]" />
            ) : (
              <i className="ri-menu-line text-2xl text-[#172C37]" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-8 py-4 flex flex-col gap-1">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-base font-medium text-[#172C37] text-left py-3 border-b border-gray-100 last:border-b-0 cursor-pointer hover:text-[#172C37]/60 transition-colors"
            >
              {item.label}
            </button>
          ))}
          <div className="flex items-center justify-between mt-3 gap-3">
            <a href="tel:+6593651286" className="text-[#172C37] font-bold text-sm">
              +65 9365 1286
            </a>
            <button
              onClick={() => scrollTo('enquiry-form')}
              className="bg-[#172C37] text-white text-sm font-bold px-5 py-2.5 rounded-full hover:opacity-70 transition-opacity whitespace-nowrap cursor-pointer"
            >
              Book Viewing
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
